import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const SafeHTMLPreview = ({ html, title }) => (_jsx("iframe", { title: title, sandbox: "", srcDoc: html, style: { width: "100%", height: "100%", border: "none" } }));
export default SafeHTMLPreview;
